import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.datalist = this.element.parentElement.querySelector("datalist");
    this.options = Array.from(this.datalist.options);
    this.hiddenTarget = this.element.parentElement.querySelector(
      "input[type='hidden']"
    );
  }

  updateMainBranchGroupId(event) {
    const value = event.target.value;
    const matchedOption = this.options.find((option) => option.value === value);
    if (matchedOption) {
      this.hiddenTarget.value = matchedOption.dataset.mainBranchGroupId;
    } else {
      this.hiddenTarget.value = "";
    }
  }
}
